import './LocationListScreen.scss';

import React, {useCallback, useEffect, useState} from 'react';
import LocationListTableComponent from "./location-list-table/LocationListTableComponent";
import {CommonService} from "../../shared/services";
import AddIcon from "@mui/icons-material/Add";
import {Download} from "@mui/icons-material";
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import {Link} from "react-router-dom";
import {IAPIResponseType} from "../../shared/models/api.model";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import LocationFiltersComponent from "./location-filters/LocationFiltersComponent";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {IRootReducerState} from "../../store/reducers";
import _ from "lodash";
import SearchComponent from "../../shared/components/search/SearchComponent";
import commonService from "../../shared/services/common.service";

interface LocationListScreenProps {

};

const FiltersInitialState: any = {
    search: '',
    types:[],//locationTypes: [],sending as types
    locationTypesObjs: [],
    facilityIds:[],
    facilityIdsObjs: [],
    createdByObjs: [],
    createdByIds: [],
    statuses: [],
    statusesObjs: [],
    cities: [],
    citiesObjs: [],
    startDate: '',
    endDate: ''
}

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['statusesObjs', 'createdByObjs', 'locationTypesObjs','facilityIdsObjs', 'citiesObjs'];


const LocationListScreen = (props: LocationListScreenProps) => {
    const [isCSVDownloading, setIsCSVDownloading] = useState(false);
    const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
    const dispatch = useDispatch();
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const {
        locationStatusList,
        facilityTypesList,
        userList,
        citiesListLite
    } = useSelector((state: IRootReducerState) => state.staticData);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);

    useEffect(() => {
        dispatch(setCurrentNavParams("Location","Location"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const downloadCSV = useCallback(() => {
        const payload = {...filterData};
        setIsCSVDownloading(true);
        CommonService._location.downloadLocationCSV(payload)
            .then((response: IAPIResponseType<any>) => {
                setIsCSVDownloading(false);
                if (response && response?.data && response?.data?.attachmentUrl) {
                    CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'location.csv', 'csv');
                }
            })
            .catch((error: any) => {
                setIsCSVDownloading(false);
            });
    }, [filterData]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
                startDate: queryParamData.startDate || '',
                endDate: queryParamData.endDate || '',
            };
            if (queryParamData?.statuses?.length) {
                data['statuses'] = queryParamData.statuses.split(',') || [];
            }
            data['statusesObjs'] = locationStatusList.filter((item: any) => data['statuses']?.includes(item?.code));

            if (queryParamData?.createdByIds?.length) {
                data['createdByIds'] = queryParamData.createdByIds.split(',') || [];
            }
            data['createdByObjs'] = userList.filter((item: any) => data['createdByIds']?.includes(item?.id?.toString()));

            if (queryParamData?.types?.length) {
                data['types'] = queryParamData.types.split(',') || [];
            }
            data['locationTypesObjs'] = facilityTypesList.filter((item: any) => data['types']?.includes(item?.code));

            if (queryParamData?.facilityIds?.length) {
                data['facilityIds'] = queryParamData.facilityIds.split(',') || [];
            }
            data['facilityIdsObjs'] = facilityTypesList.filter((item: any) => data['facilityIds']?.includes(item?.code));

            if (queryParamData?.cities?.length) {
                data['cities'] = queryParamData.cities.split(',') || [];
            }
            data['citiesObjs'] = citiesListLite?.filter((item: any) => data['cities']?.includes(item?.city));

            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData, locationStatusList, facilityTypesList, citiesListLite, userList]);

    const applyFilters = useCallback((filterData: any) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            ...filterData
        }));
        setShowFiltersDrawer(false);
    }, []);

    useEffect(() => {
        CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
    }, [filterData]);

    const clearAllFilters = useCallback(() => {
        setFilterData(_.cloneDeep(FiltersInitialState));
    }, []);

    return (
        <div className="location-list-screen screen">
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search"}
                                placeholder={"Search by location name"}
                                id="search_input"
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="page-extra-options">
                            {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                            <ButtonComponent
                                type="button"
                                id="clear_all_filters"
                                color={"secondary"}
                                variant={"text"}
                                fullWidth={false}
                                className={"clear-all-filters"}
                                handleClick={clearAllFilters}
                            >
                                Clear All
                            </ButtonComponent>}
                            <ButtonComponent
                                type="button"
                                id="csv_btn"
                                color={"primary"}
                                variant={"outlined"}
                                fullWidth={false}
                                handleClick={() => setShowFiltersDrawer(true)}
                                startIcon={<FilterAltIcon/>}>
                                Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                            </ButtonComponent>
                            {
                                commonService.checkAccess('Location',
                                    'locationCsvDownload', currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"secondary"}
                                    isLoading={isCSVDownloading}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    handleClick={downloadCSV}
                                    disabled={isCSVDownloading}
                                    startIcon={<Download/>}
                                >
                                    CSV
                                </ButtonComponent>
                            }

                            {
                                commonService.checkAccess('Location',
                                    'locationAdd', currentUser?.userAccessModules) &&
                                <Link to={CommonService._routeConfig.LocationAddRoute()}>
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        id="add_location_button"
                                        startIcon={<AddIcon/>}
                                    >
                                        New Location
                                    </ButtonComponent>
                                </Link>
                            }
                        </div>
                    </div>
                    <>
                        <LocationListTableComponent
                            isColumnFilterVisible={true}
                            filterData={filterData}/>
                    </>
                </div>
            </div>

            <DrawerComponent open={showFilterDrawer}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             onClose={() => setShowFiltersDrawer(false)}
            >
                <LocationFiltersComponent filtersData={filterData} onFiltersApply={applyFilters} clearAllFilters={clearAllFilters}/>
            </DrawerComponent>

        </div>
    );
};

export default LocationListScreen;
